'use client'

import { CheckIcon } from '@radix-ui/react-icons'
import { SubmitButton } from '@vendure/shared/ui'
import { useFormStatus } from 'react-dom'
import { HiOutlineShoppingBag } from 'react-icons/hi'

export const AddToCardButton = ({ isInCart }: { isInCart?: boolean }) => {
  const { pending } = useFormStatus()
  return (
    <SubmitButton
      variant="lead"
      className="flex items-center"
      size="lg"
      loading={pending}
      disabled={isInCart}
    >
      {isInCart ? (
        <CheckIcon className="me-2" />
      ) : (
        <HiOutlineShoppingBag className="me-2" />
      )}
      {isInCart ? 'Already in cart' : 'Buy now'}
    </SubmitButton>
  )
}
